export default __webpack_public_path__ + "static/media/log.e50be346.png";